import { postStopApi } from '../../../services/StopApi/StopApi';
import { ADHOC_QUERY_URL } from '../../../constants';

// Execute ad hoc query
export const executeAdHocQuery = async (params) => {
  const { sql, authorization } = params;

  const url = ADHOC_QUERY_URL;
  const payload = {
    sqlQuery: sql,
  };

  try {
    const response = await postStopApi({ url, payload, authorization });

    if (response && response.succeeded) {
      return {
        succeeded: true,
        data: response.data || [],
        totalRecords: response.totalRecords || (response.data ? response.data.length : 0),
        message: response.message || 'Query executed successfully',
      };
    } else {
      return {
        succeeded: false,
        error: response?.message || 'Query execution failed',
        data: [],
      };
    }
  } catch (error) {
    console.error('Error executing ad hoc query:', error);
    return {
      succeeded: false,
      error: error.toString() || 'An error occurred while executing the query',
      data: [],
    };
  }
};
